import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./image.css.ts.vanilla.css-mistica.js";
var f = 300, n = "_17tt25r1 _1y2v1nfeb _1y2v1nfeq _1y2v1nfb7 _1y2v1nfbs _1y2v1nfc9 _1y2v1nffz _1y2v1nfdk _1y2v1nfdl";
export { f as FADE_IN_DURATION_MS, n as image };
